module.exports = __webpack_public_path__ + "video/500_PAB_2021_DifferenceBetweenSpamPhishSpearPhish.2bdfd44e.vtt";